import { useContext, useMemo } from "react";

import { Context as IntlContext } from "context/Intl";
import type { MegaMenuPanelLabels } from "./mega-menu";

import { SERVICES_MENU_PANEL, buildServicesMenuCategories } from "./config";

export function useServicesMenuLabels(): {
    categories: ReturnType<typeof buildServicesMenuCategories>;
    panelLabels: MegaMenuPanelLabels;
} {
    const intl = useContext(IntlContext);

    return useMemo(
        () => ({
            categories: buildServicesMenuCategories((key) => intl.formatMessage(key)),
            panelLabels: {
                title: intl.formatMessage(SERVICES_MENU_PANEL.catalogKey),
                viewAllHref: SERVICES_MENU_PANEL.viewAllHref,
                viewAllLabel: intl.formatMessage(SERVICES_MENU_PANEL.viewAllKey),
                ariaLabel: intl.formatMessage(SERVICES_MENU_PANEL.ariaLabelKey),
            },
        }),
        [intl],
    );
}
